import { createSlice } from "@reduxjs/toolkit";
import {
  getApiResponseErrorMessage,
  isUploadIssueResponse,
} from "../../common/apiResponse";
import { createAiCampaignAPI } from "../../services/createAiCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createAiCampaignSlice = createSlice({
  name: "createAiCampaign",
  initialState: data,
  reducers: {
    createAiCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    createAiCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Campaign created successfully";
      state.error = "";
    },
    createAiCampaignInfoFailure(state, action) {
      state.isLoading = false;
      const payload = action.payload;

      if (isUploadIssueResponse(payload)) {
        state.data = payload;
        state.message = "";
        state.error = getApiResponseErrorMessage(payload) || "";
        return;
      }

      state.message = "";
      state.error =
        typeof payload === "string"
          ? payload
          : payload?.message != null
            ? String(payload.message)
            : Array.isArray(payload?.errors)
              ? payload.errors.map(String).join(" ")
              : payload != null
                ? String(payload)
                : "Something went wrong";
      state.data = null;
    },
    createAiCampaignInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createAiCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(createAiCampaignAction.createAiCampaignInfo());
	  const response = await createAiCampaignAPI(payload);
	  
    dispatch(createAiCampaignAction.createAiCampaignInfoSuccess(response));
  } catch (e) {
    dispatch(createAiCampaignAction.createAiCampaignInfoFailure(e));
  }
};

export default createAiCampaignSlice.reducer;
export const createAiCampaignAction = createAiCampaignSlice.actions;
